(function($) {
		
   /*
	*  new_map
	*
	*  This function will render a Google Map onto the selected jQuery element
	*
	*  @type	function
	*  @date	8/11/2013
	*  @since	4.3.0
	*
	*  @param	$el (jQuery element)
	*  @return	n/a
	*/
	
	function new_map( $el ) {
		
		// Check if Google Maps is fully loaded
		if (typeof google === 'undefined' || typeof google.maps === 'undefined' || 
		    typeof google.maps.LatLng === 'undefined' || typeof google.maps.Map === 'undefined') {
			console.warn('Google Maps API not fully loaded yet');
			return null;
		}
		
		// var
		var $markers = $el.find('.marker');
		
		
		// vars
		var args = {
			zoom		: 16,
			center		: new google.maps.LatLng(0, 0),
			mapTypeId	: google.maps.MapTypeId.ROADMAP
		};
		
		
		// create map	        	
		var map = new google.maps.Map( $el[0], args);
		
		
		// add a markers reference
		map.markers = [];
		
		
		// add markers
		$markers.each(function(){
			
	    	add_marker( $(this), map );
			
		});
		
		
		// center map
		center_map( map );
		
		
		// return
		return map;
		
	}
	
	/*
	*  add_marker
	*
	*  This function will add a marker to the selected Google Map
	*
	*  @type	function
	*  @date	8/11/2013
	*  @since	4.3.0
	*
	*  @param	$marker (jQuery element)
	*  @param	map (Google Map object)
	*  @return	n/a
	*/
	
	function add_marker( $marker, map ) {
	
		// var
		var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
		var args = {
			position	: latlng,
			map			: map
		};
		if($marker.attr('data-logo')){
			args.icon = $marker.attr('data-logo');
		}
		// create marker
		var marker = new google.maps.Marker(args);
	
		// add to array
		map.markers.push( marker );
	
		// if marker contains HTML, add it to an infoWindow
		if( $marker.html() )
		{
			// create info window
			var infowindow = new google.maps.InfoWindow({
				content		: $marker.html()
			});
	
			// show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', function() {
	
				infowindow.open( map, marker );
	
			});
		}
	
	}
	
	/*
	*  center_map
	*
	*  This function will center the map, showing all markers attached to this map
	*
	*  @type	function
	*  @date	8/11/2013
	*  @since	4.3.0
	*
	*  @param	map (Google Map object)
	*  @return	n/a
	*/
	
	function center_map( map ) {
	
		// vars
		var bounds = new google.maps.LatLngBounds();
	
		// loop through all markers and create bounds
		$.each( map.markers, function( i, marker ){
	
			var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
	
			bounds.extend( latlng );
	
		});
	
		// only 1 marker?
		if( map.markers.length == 1 )
		{
			// set center of map
		    map.setCenter( bounds.getCenter() );
		    map.setZoom( 16 );
		}
		else
		{
			// fit to bounds
			map.fitBounds( bounds );
		}
	
	}
	
	/*
	*  document ready
	*
	*  This function will render each map when the document is ready (page has loaded)
	*
	*  @type	function
	*  @date	8/11/2013
	*  @since	5.0.0
	*
	*  @param	n/a
	*  @return	n/a
	*/
	// global var
	var map = null;
	var mapsInitialized = false;
	
	function initializeMaps() {
		// Prevent multiple initializations
		if (mapsInitialized) {
			console.log('Maps already initialized, skipping...');
			return;
		}
		
		$('.location-map').each(function(){
			var $mapElement = $(this);
			
			// Skip if this map was already initialized
			if ($mapElement.data('map-initialized')) {
				return;
			}
			
			// create map
			var mapInstance = new_map( $mapElement );
			
			if (mapInstance) {
				// Mark as initialized
				$mapElement.data('map-initialized', true);
				$mapElement.data('map-instance', mapInstance);
				
				// Store the last created map in the global var
				map = mapInstance;
			}
		});
		
		mapsInitialized = true;
	}
	
	// Helper function to check if Google Maps API is fully loaded
	function isGoogleMapsReady() {
		return typeof google !== 'undefined' && 
		       typeof google.maps !== 'undefined' && 
		       typeof google.maps.LatLng !== 'undefined' &&
		       typeof google.maps.Map !== 'undefined' &&
		       typeof google.maps.Marker !== 'undefined' &&
		       typeof google.maps.InfoWindow !== 'undefined' &&
		       typeof google.maps.LatLngBounds !== 'undefined';
	}
	
	$(document).ready(function(){
		// Check if Google Maps is already loaded
		if (isGoogleMapsReady()) {
			initializeMaps();
		} else {
			// Wait for Google Maps to load via callback or custom event
			$(document).on('googleMapsLoaded', function() {
				// Double-check that Google Maps is fully loaded before initializing
				if (isGoogleMapsReady()) {
					initializeMaps();
				} else {
					// If not ready yet, wait a bit more
					setTimeout(function() {
						if (isGoogleMapsReady()) {
							initializeMaps();
						}
					}, 500);
				}
			});
			
			// Fallback: check periodically if Google Maps has loaded
			var checkGoogleMaps = setInterval(function() {
				if (isGoogleMapsReady()) {
					clearInterval(checkGoogleMaps);
					initializeMaps();
				}
			}, 100);
			
			// Stop checking after 10 seconds to avoid infinite loops
			setTimeout(function() {
				clearInterval(checkGoogleMaps);
				if (!isGoogleMapsReady()) {
					console.error('Google Maps API failed to load within 10 seconds');
				}
			}, 10000);
		}
	});
	
})(jQuery);